var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":(_vm.label || _vm.$t('depot')),"items":_vm.depots,"item-value":"id","item-text":"name","rules":[_vm.validate]},on:{"change":_vm.handleChange},model:{value:(_vm.depotId),callback:function ($$v) {_vm.depotId=$$v},expression:"depotId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }